const PromoCodes = require("../components/PromoCodes");
const { connect } = require("react-redux");
const { addPromoCode } = require("actions/promocodes");

module.exports = connect(
    state => ({
        isSaving: state.promocodes.isSaving
    }),
    { addPromoCode }
)(PromoCodes);



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes-add/containers/PromoCodes.js